import { FC } from 'react';
import { Badge, BadgeProps } from '@chakra-ui/react';

import { FileStatus } from '../../graphql/generated';

export type StatusConfig = {
  label: string;
  colorScheme?: string;
  tooltip?: string;
};

type FileStatusBadgeProps = BadgeProps & {
  status: FileStatus;
};

export const FileStatusMap: Record<FileStatus, StatusConfig> = {
  [FileStatus.AWAITING_UPLOAD]: {
    label: 'Awaiting upload',
    colorScheme: 'blue',
  },
  [FileStatus.PROCESSING]: { label: 'Processing', colorScheme: 'blue' },
  [FileStatus.PROCESSED]: { label: 'Processed', colorScheme: 'green' },
  [FileStatus.ERROR]: { label: 'Error', colorScheme: 'red' },
  [FileStatus.UPLOADED]: { label: 'Uploaded', colorScheme: 'green' },
};

export const FileStatusBadge: FC<FileStatusBadgeProps> = ({
  status,
  ...rest
}) => {
  const statusMap = FileStatusMap[status];
  return (
    <Badge variant="outline" colorScheme={statusMap.colorScheme} {...rest}>
      {statusMap.label}
    </Badge>
  );
};
